import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  justify-content: center; /* Center the content horizontally */
  width: 100%; /* Occupy the full width of the parent */
  max-width: 600px; /* Adjust max-width as needed */
  margin: 0 auto; /* Center the container on the page */
`;

export const PositionCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem;
  padding: 1rem;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center; /* Center the content horizontally */
`;

// export const FormContainer = styled.div`
//   border-radius: 8px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//   display: grid;
//   grid-template-columns: repeat(2, 1fr);
//   gap: 10px;
//   padding: 20px;
//   width: 100%;
//   background-color: #f7f7f7;
//   max-width: 480px;
//   margin: 0 auto;
//   place-items: center; /* Center content horizontally and vertically */
// `;

// export const PositionCard = styled.div`
//   background-color: #fff;
//   border-radius: 8px;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
//   margin-bottom: 1rem; // Consistent spacing between cards
//   padding: 1rem;
//   width: 100%; // Card width fills the container
//   box-sizing: border-box; // Include padding and border in the width and height
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start; // Align text to the start
//   justify-self: center; // Center horizontally within the grid cell
// `;

export const FormTitle = styled.h3`
  grid-column: 1 / -1; // Spans full width
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  text-align: center; // Center the text
`;

export const InputGroup = styled.div`
  grid-column: 1 / -1; // Spans full width
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 1rem;
`;

export const Input = styled.input`
  border: 2px solid #e2e8f0;
  border-radius: 4px;
  padding: 0.5rem;
  font-size: 1rem;
  &:focus {
    border-color: #cbd5e0;
  }
`;

export const MaxButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #ebf8ff;
  color: #3182ce;
  border: none;
  border-radius: 0 4px 4px 0; // Round the right corners
  cursor: pointer;
  &:hover {
    background-color: #bee3f8;
  }
`;

export const CurrentPriceContainer = styled.div`
  grid-column: 1 / -1; // Spans full width
  background-color: #edf2f7;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  margin: 1rem 0;
`;

export const CurrentPriceLabel = styled.span`
  font-size: 1rem;
  color: #4a5568;
`;

export const CurrentPriceValue = styled.span`
  font-size: 1rem;
  color: #2b6cb0;
  font-weight: bold;
`;


export const SubmitButton = styled.button`
  grid-column: 1 / -1; // Spans full width
  background-color: #48bb78;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0.8rem;
  font-size: 1rem;
  cursor: pointer;
  &:hover {
    background-color: #38a169;
  }
`;

// Now you can apply these styles to your component structure accordingly.
export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const DesiredPriceDisplay = styled.div`
  margin-top: 10px; // Adjust spacing as needed
  font-size: 1.2rem; // Adjust font size as needed
  color: #4a5568; // Adjust text color as needed
  font-weight: bold; // Bold text to make it stand out
`;

export const AmountInput = styled.input`
  flex: 1;
  padding: 10px;
  border: none; // Remove individual border
  border-radius: 4px; // Match your Input border-radius
  -moz-appearance: textfield; // Removes the spinner for Firefox
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none; // Removes the spinner for WebKit browsers like Chrome
    margin: 0;
  }
  font-size: 1rem; // Match this size to your price input's font size
  &:focus {
    outline: none; // Optional: Removes the outline on focus
  }
`;
